import _ from "lodash";

export const calculateNextSequence = (
  existingCourses,
  addedCourses,
  gradeMapId
) => {
  const maxFromBackend = getMaxSequence(existingCourses);
  const maxFromNewCourses = getMaxSequenceForGradeMap(addedCourses, gradeMapId);
  return Math.max(maxFromBackend, maxFromNewCourses) + 1;
};

const getMaxSequence = courses => {
  return _.max(_.map(courses, "displaySequence")) || 0;
};

const getMaxSequenceForGradeMap = (addedCourses, gradeMapId) => {
  const filteredCourses = _.filter(
    addedCourses,
    course => course.studentGradeMapId === gradeMapId
  );
  return _.max(_.map(filteredCourses, "displaySequence")) || 0;
};
